const socialLoginErrors = ["SOCIAL_AUTH_CONNECT_VERIFY_EMAIL"];
export default socialLoginErrors;
